/**
 * Type guard function that checks if a value is a string.
 * Returns true if the value is a string, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is a string, false otherwise
 *
 * @example
 * ```ts
 * import { IsString } from "@pdfking/tfunc"
 *
 * const str = "hello";
 * const num = 42;
 *
 * if (IsString(str)) {
 *   console.log(str.toUpperCase()); // "HELLO" (type narrowed to string)
 * }
 *
 * if (IsString(num)) {
 *   // This block won't execute
 * }
 *
 * // Use in filtering
 * const mixed = [1, "two", 3, "four"];
 * const strings = mixed.filter(IsString); // ["two", "four"]
 * ```
 */
export const IsString = <T>(value: T): value is string & T =>
  typeof value === "string"
